<template>
  <div id="first-ig">
    <div class="ig">
      <ImagesBoard/>
    </div>

    <div class="text-center">
      <button class="btn btn-loadmore">Load more</button>
    </div>
  </div>
</template>

<script>
import ImagesBoard from "@/components/ImagesBoard";

export default {
  name: "first-ig",
  components: {
    ImagesBoard
  }
};
</script>

<style lang="scss" scoped>
#first-ig {
  .ig {
    background-color: #cccccc;
    min-height: 544px;
    margin-bottom: 30px;
  }

  .btn-loadmore {
    border: 2px #e13036 solid;
    color: #e13036;
  }
}
</style>


